export const VALIDATION_REGEX = /([^A-Za-z0-9-]+)/g;
